import React, { useEffect, useRef, useState } from "react";

import { GenericTable, Input, toastMessage, Button, tCell, ActionMenu, Dialog, Dropdown, Checkbox, ConfirmationDialog } from "../utils/index";
import theme, { buttonClasses } from "../utils/theme";
import { useOrgs, useTags, useUserDetail, useUserPermissions, useVehicles, useProductCategories, useProducts, useSuppliers, usePlant } from "../../services/hooks";
import { fakeFileInput, formatDate, isObjectEqual } from "../../services/functions";
import { useAddTagMutation, useDeleteTagMutation, useUpdateTagMutation, useUploadBulkTagMutation } from "../../api/deviceSlice";
import { useMapVehicleTagMutation } from "../../api/vmsSlice";
import { Navigate } from "react-router-dom/dist";
import Genericfilter from "../utils/Genericfilter";
import { debounce } from "../../services/functions";
import { Grid } from "@mui/material";
import { GenericstatsV2 } from "../utils/Genericstats";
import CommonTour, { TourIcon } from "../Tour/CommonTour";
import { includes_special_char } from "../../services/validation";
import { usePlantContext } from "../../context/plantContext";
const tagTourDummyData = [
	{
		allocationDetails: {
			assetType: "vehicle",
			assetId: "67cac4225134ebe1417eb1c7",
			assetName: "XX00XX0000",
		},
		allocatedOn: "2025-03-18T07:47:20.807Z",
		assetId: "67cac4225134ebe1417eb1c7",
		assetName: "XX00XX0000",
		assetType: "vehicle",
		created_by: {
			user_id: "65fbd96d6bc11b2703fac28d",
			user_type: "admin",
			name: "ashishAdmin",
			email: "ashishtest@gmail.com",
		},
		created_on: "2025-03-18T07:47:20.503Z",
		displayName: "Smart Highway Tag",
		epc: "000XX000000XXX000",
		modified_by: {
			user_id: "65fbd96d6bc11b2703fac28d",
			user_type: "admin",
			name: "ashishAdmin",
			email: "ashishtest@gmail.com",
		},
		modified_on: "2025-03-18T07:47:20.808Z",
		orgId: "65fbd1a953312156626a627d",
		orgName: "Test seventh Company",
		project: "LYNKID",
		status: "Allocated",
		tId: "24354535445534",
		tagType: "Fast Tag",
		__v: 0,
		_id: "67d925089c18e3c6f131176e",
	},
];

const SAMPLE_EXCEL_PATH = "/sample_excels/tag_sample.xlsx";
const EXCEL_TYPE = "tag";

const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};

const TagManagement = () => {
	const { userPermissions, isFetched } = useUserPermissions();
	const { plantId } = usePlantContext();

	const { userDetail } = useUserDetail();
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;

	const { orgOptions } = useOrgs();
	const { plantOptions, getPlantDetails, clearPlants } = usePlant();
	// useEffect(() => {
	// 	if (userPermissions?.managePlant?.value) {
	// 		getPlantDetails({});
	// 	}
	// }, [userDetail]);
	const [isModal, setIsModal] = useState(false);
	const [isAttachTagModal, setIsAttachTagModal] = useState(false);
	const [fetchStats, setFetchStats] = useState(false);
	const [isTourCompleted, setIsTourCompleted] = useState(false);
	const tourRef = useRef();
	const [isTourMode, setIsTourMode] = useState(false);
	const shouldRunTour = !userDetail?.moduleTour?.tags;
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [tagToDelete, setTagToDelete] = useState(null);
	const filterFields = [
		{
			inputType: "textfield",
			id: "1",
			name: "epc",
			type: "text",
			label: "EPC",
			placeholder: "EPC",
			readOnly: false,
			error: "",
			value: "",
		},
		{
			inputType: "textfield",
			id: "2",
			name: "tId",
			type: "text",
			label: "TID",
			placeholder: "TID",
			readOnly: false,
			error: "",
			value: "",
		},
		{
			inputType: "textfield",
			id: "3",
			name: "displayName",
			type: "text",
			label: "Tag Name",
			placeholder: "Tag Name",
			readOnly: false,
			error: "",
			value: "",
		},
		{
			inputType: "textfield",
			id: "4",
			name: "allocatedToId",
			type: "text",
			label: "Allocated To",
			placeholder: "Allocated To",
			readOnly: false,
			error: "",
			value: "",
		},
	];
	const TagManagementTour = [
		{
			target: ".title",
			content: "Welcome to Tag Management! Here you can manage all your RFID tags and their allocations.",
			placement: "bottom",
		},
		{
			target: ".genericStats-containter",
			content: "These cards show quick statistics about your tags - total, allocated, and available counts.",
			placement: "bottom",
		},
		{
			target: "#Genericfilter",
			content: "Use these filters to search for specific tags by EPC, TID, name, or allocation status.",
			placement: "bottom",
		},
		...(userDetail?.userType !== "superAdmin"
			? [
					{
						target: ".allocateTag",
						content: "Click here to assign tags to vehicles or other assets.",
						placement: "bottom",
					},
			  ]
			: []),
		{
			target: ".addTag",
			content: "Add individual tags manually through this button.",
			placement: "left",
		},
		{
			target: ".bulkUpload",
			content: "Upload multiple tags at once using an Excel file with this button.",
			placement: "left",
		},
		{
			target: ".downloadSample",
			content: "Download a sample Excel template for bulk uploads here.",
			placement: "left",
		},
		{
			target: ".tableGeneric",
			content: "This table lists all your tags with their key information.",
			placement: "top",
		},
	];
	if (userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "orgId",
			name: "orgId",
			label: "Organization",
			error: "",
			option: orgOptions,
		});
	}
	if (shouldHandlePlant && userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "plantIds",
			name: "plantIds",
			label: "Warehouse",
			error: "",
			option: plantOptions,
		});
	}
	const onModalOpen = (type) => {
		if (type === "Attach Tag") {
			tagDataRef.current = {};
			setIsAttachTagModal(true);
		} else {
			setIsModal(true);
		}
	};
	const onModalClose = (type) => {
		if (type === "Attach Tag") {
			setIsAttachTagModal(false);
		} else {
			setIsModal(false);
			if (updateDataRef.current) {
				updateDataRef.current = null;
			}
		}
	};
	const tagDataRef = useRef(null);
	const updateDataRef = useRef(null);
	const filterRef = useRef(defaultFilter);
	if (userDetail.userType !== "superAdmin") {
		filterRef.current.plantIds = plantId;
	}

	const { page_no, pagesize } = filterRef.current;

	const { tags, count, isLoading, message, getTags } = useTags(userDetail.userType === "superAdmin" ? filterRef.current : null);
	useEffect(() => {
		if (filterRef.current && userDetail?.userType !== "superAdmin") {
			getTags(filterRef.current);
		}
	}, [plantId]);
	const [handleDelete] = useDeleteTagMutation();
	let actionHandlers = {};
	if (userPermissions?.updateTag?.value) {
		actionHandlers.edit = (id) => {
			updateDataRef.current = tags[id];
			setIsModal(true);
		};
	}
	if (userPermissions?.deleteTag?.value) {
		actionHandlers.delete = async (id) => {
			setTagToDelete(tags[id]);
			setDeleteConfirmOpen(true);
		};
	}
	if (userPermissions?.mapVehicleTag?.value) {
		actionHandlers.allocateTag = (id) => {
			tagDataRef.current = tags[id];
			setIsAttachTagModal(true);
		};
	}
	const handleDeleteConfirm = async () => {
		if (!tagToDelete) return;

		const payload = { deleteId: tagToDelete._id };
		const {
			data: { error, message },
		} = await handleDelete(payload);

		if (error) {
			toastMessage(false, message);
		} else {
			onUpdateSuccess();
			toastMessage(true, message);
		}

		setDeleteConfirmOpen(false);
		setTagToDelete(null);
	};

	const handleDeleteCancel = () => {
		setDeleteConfirmOpen(false);
		setTagToDelete(null);
	};

	let header = ["S.no", "Display Name", "TID", "EPC", "Tag Type", "Status", "Allocated To"];
	if (userDetail?.userType == "superAdmin") {
		header.push("Org Name");
	}
	if (userPermissions?.updateTag?.value || userPermissions?.deleteTag?.value) {
		header.push("Action");
	}

	const rows =
		(shouldRunTour || isTourMode ? tagTourDummyData : tags)?.map((d, i) => {
			let row = [];
			row.push(
				tCell((page_no - 1) * pagesize + i + 1),
				tCell(d.displayName),
				tCell(d.tId),
				tCell(d.epc),
				tCell(d.tagType),
				tCell(d.status),
				tCell(
					d.allocationDetails?.vehicleNumber
						? d.allocationDetails?.vehicleNumber
						: d.allocationDetails?.allocatedToName || d.allocationDetails?.allocationType
						? `${d.allocationDetails?.allocatedToName}(${d.allocationDetails?.allocationType})`
						: d.allocationDetails?.assetName && d.allocationDetails?.assetType
						? `${d.allocationDetails?.assetName} (${d.allocationDetails?.assetType})`
						: ""
				)
			);
			if (userDetail?.userType == "superAdmin") {
				row.push(tCell(d.orgName));
			}
			if ((userPermissions?.updateTag?.value || userPermissions?.deleteTag?.value) && d.status !== "Allocated") {
				row.push(
					<div style={{ paddingLeft: "0.5rem" }}>
						<ActionMenu id={i} handlers={actionHandlers} />
					</div>
				);
			} else {
				row.push("-");
			}
			return row;
		}) || [];

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		getTags(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value };
		getTags(filterRef.current);
	};
	const onUpdateSuccess = () => {
		getTags(filterRef.current);
		setFetchStats((old) => !old);
	};

	const [handleUploadExcel] = useUploadBulkTagMutation();
	const onBulkExcelUpload = () => {
		fakeFileInput(async (formData) => {
			formData.append("type", EXCEL_TYPE);
			// const payload = {
			// 	file,
			// 	type: EXCEL_TYPE,
			// };
			const {
				data: { error, message },
			} = await handleUploadExcel(formData);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				onUpdateSuccess();
			}
		});
	};

	/**
	 * We use GenericFilter component for all CRUD filters. That component maintains its own state for the filter
	 * and that object is sent here to the handleFilterChange function.
	 * Mutating this _filter object will cause the filter state to change on rerender (It's probably because of object reference in JS. The filter object from the state gets mutated and then the component gets re-rendered  due to any reason and now the state will have the mutated object)
	 * Here we have relationship between Org and Plant. On selecting an org, we will fetch its plant. So in order to clear previous selected plant when selecting different org, we will mutate the _filter object
	 */
	const handleFilterChange = (_filter) => {
		let filter = { ..._filter };

		for (let key in filter) {
			if (!filter[key]) delete filter[key];
		}
		if (userDetail.userType == "superAdmin") {
			if (filter.orgId) {
				// filter.orgId = filter.orgId?.value;
				if (shouldHandlePlant && filter.orgId != filterRef.current.orgId) {
					// when switching organization, we want to
					// - get plants for that org
					// - clear plantIds from the local filter object
					// - clear plantIds from original filter object, mutating the state and clearing the plant dropdown
					delete filter.plantIds;
					delete _filter.plantIds;
					getPlantDetails({ orgId: filter.orgId });
				}
			} else {
				clearPlants();
			}
		}
		// if (filter.plantIds) filter.plantIds = filter.plantIds?.value;
		filter.pagesize = 10;
		filter.page_no = 1;
		if (!isObjectEqual(filterRef.current, filter)) {
			filterRef.current = { ...filter };
			getTags(filterRef.current);
		}
	};

	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.getTag?.value) return <Navigate to="/not-authorized" replace />;
	const handleTourStart = () => {
		setIsTourMode(true);
		tourRef.current?.restartTour();
	};
	return (
		<div className="contentpanel">
			<CommonTour ref={tourRef} steps={TagManagementTour} moduleName="tags" onTourComplete={() => setIsTourMode(false)} />
			<Grid container spacing="0.5rem">
				<Grid item xl={6} lg={6} md={5} sm={3} xs={12}>
					<h1 className="title">
						Tag Management{" "}
						<span title="Replay Tour" onClick={handleTourStart} style={{ cursor: "pointer" }}>
							<TourIcon />
						</span>
					</h1>
				</Grid>
				<Grid item xl={6} lg={6} md={7} sm={9} xs={12}>
					<Grid container spacing="0.5rem">
						{userPermissions?.mapVehicleTag?.value ? (
							<Grid item xl={3} lg={3} md={3} sm={3} xs={12} className="allocateTag">
								<Button onClick={() => onModalOpen("Attach Tag")} text="Allocate Tag" style={buttonClasses.lynkitOrangeEmpty} />{" "}
							</Grid>
						) : null}
						{userPermissions?.addTag?.value ? (
							<Grid item xl={3} lg={3} md={3} sm={3} xs={12} className="addTag">
								<Button onClick={onModalOpen} text="Add Tag" style={buttonClasses.lynkitOrangeEmpty} />{" "}
							</Grid>
						) : null}
						{userPermissions?.addTag?.value ? (
							<Grid item xl={3} lg={3} md={3} sm={3} xs={12} className="bulkUpload">
								<Button onClick={onBulkExcelUpload} text="Bulk Upload" style={buttonClasses.lynkitOrangeFill} />
							</Grid>
						) : null}
						{userPermissions?.addTag?.value ? (
							<Grid item xl={3} lg={3} md={3} sm={3} xs={12} className="downloadSample">
								<a href={SAMPLE_EXCEL_PATH} download>
									<Button text="Download Sample" style={buttonClasses.lynkitBlackFill} />
								</a>
							</Grid>
						) : null}
					</Grid>
				</Grid>
			</Grid>

			<hr className="bgg" />
			<GenericstatsV2 statsFor={"Tag"} fetchStats={fetchStats} plantId={plantId} />
			<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear />
			<div className="tableGeneric">
				<GenericTable
					header={header}
					rows={rows}
					pageCount={count || tags?.length}
					pageNo={filterRef.current?.page_no}
					limit={filterRef.current?.pagesize}
					onPageChange={onPageChange}
					onPageSizeChange={onPageSizeChange}
					isLoading={isLoading}
				/>
			</div>
			{isModal && (
				<AddTag open={isModal} onClose={onModalClose} updateData={updateDataRef.current} onUpdateSuccess={onUpdateSuccess} assetMappingSupport={userPermissions?.assetMappingSupport?.value} />
			)}
			{isAttachTagModal && (
				<AttachTag
					open={isAttachTagModal}
					selectedTag={tagDataRef.current}
					onClose={() => onModalClose("Attach Tag")}
					onUpdateSuccess={onUpdateSuccess}
					multiTagSupport={userPermissions?.multiTagSupport?.value}
					assetMappingSupport={userPermissions?.assetMappingSupport?.value}
				/>
			)}
			<ConfirmationDialog open={deleteConfirmOpen} handleClose={handleDeleteCancel} handleSubmit={handleDeleteConfirm} title="Delete Tag" submitText="Delete">
				Are you sure you want to delete this tag? This action cannot be undone.
			</ConfirmationDialog>
		</div>
	);
};

export default TagManagement;

const defaultForm = {
	displayName: "", // required
	tagType: "", // required
	tId: "", // required
	epc: "", // required
	updateId: undefined,
	orgId: undefined,
	plantId: "",
	assetType: "vehicle",
	assetId: "",
	isTrackable: true,
};
function fillUpdateData(data) {
	return {
		displayName: data.displayName,
		tagType: data.tagType,
		tId: data.tId,
		epc: data.epc,
		updateId: data._id,
		orgId: data.orgId,
		plantId: data.plantId || "",
		assetType: "vehicle",
		assetId: data.assetId,
		isTrackable: data.isTrackable,
	};
}

const tagTypeOptions = [
	{ label: "--select--", value: "" },
	{ label: "Fast Tag", value: "Fast Tag" },
	{ label: "Fixed Tag", value: "Fixed" },
	{ label: "Temporary Tag", value: "Temporary" },
];

function AddTag({ onClose, open, updateData, onUpdateSuccess, multiTagSupport, assetMappingSupport }) {
	const [formData, setFormData] = useState(updateData ? fillUpdateData(updateData) : defaultForm);
	const [error, setError] = useState({});

	const { userDetail } = useUserDetail();
	const { userPermissions } = useUserPermissions();
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;

	const { orgOptions } = useOrgs();
	const orgValue = orgOptions.find((_) => _.value == formData.orgId);
	const { plantId } = usePlantContext();
	const { plantOptions, clearPlants, getPlantDetails } = usePlant();
	const plantValue = plantOptions.find((_) => formData.plantId == _.value);
	// useEffect(() => {
	// 	if (shouldHandlePlant) {
	// 		getPlantDetails({});
	// 	}
	// }, [userDetail]);

	const [allocateTag, setAllocateTag] = useState(false);

	const vehicleRef = useRef({
		page_no: "1",
		pagesize: "25",
		search: "",
		searchBy: "vehicle",
	});
	const { vehicleOptions, isLoading: isVehicleLoading, refetch } = useVehicles(vehicleRef.current);
	const { getProdCats, options: prodCatOpts } = useProductCategories();
	const { getProducts, productOptions } = useProducts();
	const { getSuppliers, supplierOptions } = useSuppliers();

	let assetOptions = [];
	switch (formData.assetType) {
		case "vehicle": {
			assetOptions = vehicleOptions;
			break;
		}
		case "productCategory": {
			assetOptions = prodCatOpts;
			break;
		}
		case "product": {
			assetOptions = productOptions;
			break;
		}
		case "supplier": {
			assetOptions = supplierOptions;
			break;
		}
	}

	const onInputChange = debounce((e) => {
		switch (formData.assetType) {
			case "vehicle": {
				vehicleRef.current = {
					page_no: "1",
					pagesize: "25",
					search: e.target.value,
					searchBy: "vehicle",
				};
				refetch();
				break;
			}
			case "productCategory":
				getProdCats({ ...defaultFilter, productCategory: e.target.value });
				break;
			case "product":
				getProducts({ ...defaultFilter, productName: e.target.value });
				break;
			case "supplier":
				getSuppliers({ ...defaultFilter, supplierName: e.target.value });
				break;
		}
	}, 500);

	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData((old) => ({ ...old, [name]: value }));
	};
	const onDropdownChange = (option, name) => {
		let value = Array.isArray(option) ? option.map((_) => _.value) : option?.value || "";

		handleInput({ target: { name, value } });

		if (name == "assetType") {
			switch (value) {
				case "vehicle":
					refetch();
					break;
				case "productCategory":
					getProdCats(defaultFilter);
					break;
				case "product":
					getProducts(defaultFilter);
					break;
				case "supplier":
					getSuppliers(defaultFilter);
					break;
			}
		}
		if (name == "orgId" && shouldHandlePlant) {
			if (value) {
				getPlantDetails({ orgId: value });
			} else {
				clearPlants();
			}
		}
	};
	const [handleAdd, { isLoading: isAdding }] = useAddTagMutation();
	const [handleUpdate, { isLoading: isUpdating }] = useUpdateTagMutation();
	const tagTypeValue = tagTypeOptions.find((option) => option.value === formData.tagType);

	const handleFormSubmit = async () => {
		const payload = { ...formData, orgName: orgValue?.label || userDetail.orgName ,  plantId: userDetail?.userType === "superAdmin" ? formData.plantId : plantId};
		// const payload = {
		// 	...formData,
		// 	tId: formData?.tId ? formData.tId.toLowerCase() : "",
		// 	epc: formData?.epc ? formData.epc.toLowerCase() : "",
		// 	orgName: orgValue?.label || userDetail.orgName,
		// 	plantId: userDetail?.userType === "superAdmin" ? formData.plantId : plantId,
		// };
		// console.log(payload);
		const {
			data: { error, message },
		} = updateData ? await handleUpdate(payload) : await handleAdd(payload);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			onUpdateSuccess();
			handleClose();
		}
	};

	const handleFormValidation = () => {
		let error = {};
		if (userDetail?.userType == "superAdmin" && !formData.orgId) error.orgId = "Organization name is required";
		if (shouldHandlePlant && !formData.plantId.length && userDetail.userType === "superAdmin") error.plantId = "Warehouse is required";
		if (!formData.displayName) error.displayName = "Display name is required";
		if (!formData.tagType) error.tagType = "Tag type is required";
		if (!formData.tId && !formData.epc) error.tId = "TID or EPC is required";
		if (!formData.epc && !formData.tId) error.epc = "EPC or TID is required";
		if (formData.tId && includes_special_char(formData.tId)) error.tId = "Invalid TID format";
		if (formData.epc && includes_special_char(formData.epc)) error.epc = "Invalid EPC format";
		if (allocateTag && !formData.assetId) error.assetId = "Asset is required";

		if (Object.keys(error).length) {
			setError(error);
		} else {
			handleFormSubmit();
		}
	};
	const handleClose = () => {
		setFormData(defaultForm);
		setError({});
		onClose();
	};
	return (
		<Dialog size="xs" open={open} handleClose={handleClose} handleSubmit={handleFormValidation} title={updateData ? "Update Tag" : "Add Tag"} isSubmitDisabled={isAdding || isUpdating}>
			<form className="">
				<div className="form-inputs mt-2">
					{userDetail?.userType == "superAdmin" ? (
						<Dropdown id="orgIdAdd" name="orgId" label="Organization" onChange={onDropdownChange} options={orgOptions} value={orgValue} required error={error.orgId} />
					) : null}
					{shouldHandlePlant && userDetail.userType === "superAdmin" ? (
						<Dropdown id="plantIdAdd" name="plantId" label="Warehouse" onChange={onDropdownChange} options={plantOptions} value={plantValue} required error={error.plantId} />
					) : null}
					<Input label="Display Name" placeholder="Enter Display Name" name="displayName" value={formData.displayName} onChange={handleInput} required error={error.displayName} />
					<Dropdown id="tagType" name="tagType" label="Tag Type" onChange={onDropdownChange} options={tagTypeOptions} value={tagTypeValue} required error={error.tagType} />

					<Input label="Tag TID" placeholder="Enter Tag TID" name="tId" value={formData.tId} onChange={handleInput} required error={error.tId} />
					<Input label="Tag EPC" placeholder="Enter Tag EPC" name="epc" value={formData.epc} onChange={handleInput} required error={error.epc} />

					{updateData ? null : (
						<>
							<Checkbox
								name="allocateTag"
								checked={allocateTag}
								onChange={(e) => {
									setAllocateTag(e.target.checked);
								}}
								label="Allocate Tag"
							/>
							{allocateTag ? (
								<>
									<Dropdown
										id={"assetType"}
										name={"assetType"}
										label={"Select Asset Type"}
										onChange={onDropdownChange}
										options={assetMappingSupport ? multiAssetTypeOptions : assetTypeOptions}
										value={multiAssetTypeOptions.find((ele) => ele.value === formData.assetType)}
										error={error.assetType}
									/>
									<Dropdown
										id={"vehicleId"}
										name={"assetId"}
										label={"Select Asset"}
										onChange={onDropdownChange}
										onInputChange={onInputChange}
										options={isVehicleLoading ? [{ label: "Loading...", value: "loading" }] : assetOptions || []}
										value={assetOptions.find((ele) => ele.value === formData.assetId)}
										error={error.assetId}
										getOptionDisabled={(option) => {
											// disable vehicle option when org doesnt have multi tag support and vehicle has been allocated a tag
											if (formData.assetType == "vehicle" && !userPermissions?.multiTagSupport?.value && (option?.data?.formData?.epc || option?.data?.formData?.tId)) {
												return true;
											}
											return false;
										}}
									/>
									<Checkbox
										id={"isTrackable"}
										name={"isTrackable"}
										checked={formData.isTrackable}
										onChange={() => setFormData((old) => ({ ...old, isTrackable: !old.isTrackable }))}
										label="Is Trackable"
									/>
								</>
							) : null}
						</>
					)}
				</div>
			</form>
		</Dialog>
	);
}

const defaultAttachTagForm = {
	assetType: "vehicle",
	assetId: "",
	isTrackable: true,
	tagData: [],
};

let assetTypeOptions = [{ label: "Vehicle", value: "vehicle" }];

let multiAssetTypeOptions = [
	{ label: "Vehicle", value: "vehicle" },
	{ label: "Product", value: "product" },
	{ label: "Product Category", value: "productCategory" },
	{ label: "Supplier", value: "supplier" },
	// { label: "Asset", value: "asset" },
];

function AttachTag({ onClose, selectedTag, open, onUpdateSuccess, multiTagSupport, assetMappingSupport }) {
	const { userPermissions } = useUserPermissions();
	const { plantId } = usePlantContext();
	const [formData, setFormData] = useState(
		selectedTag && Object.keys(selectedTag).length > 0
			? { ...defaultAttachTagForm, tagData: [{ tag_tid: selectedTag.tId, tag_epc: selectedTag.epc, tagType: selectedTag.tagType, displayName: selectedTag.displayName }] }
			: defaultAttachTagForm
	);
	const [error, setError] = useState({});

	const vehicleRef = useRef({
		page_no: "1",
		pagesize: "25",
		search: "",
		searchBy: "vehicle",
	});
	const { vehicleOptions, isLoading: isVehicleLoading, refetch } = useVehicles(vehicleRef.current);
	const { getProdCats, options: prodCatOpts } = useProductCategories();
	const { getProducts, productOptions } = useProducts();
	const { getSuppliers, supplierOptions } = useSuppliers();

	let assetOptions = [];
	switch (formData.assetType) {
		case "vehicle": {
			assetOptions = vehicleOptions;
			break;
		}
		case "productCategory": {
			assetOptions = prodCatOpts;
			break;
		}
		case "product": {
			assetOptions = productOptions;
			break;
		}
		case "supplier": {
			assetOptions = supplierOptions;
			break;
		}
	}

	const onInputChange = debounce((e) => {
		switch (formData.assetType) {
			case "vehicle": {
				vehicleRef.current = {
					page_no: "1",
					pagesize: "25",
					search: e.target.value,
					searchBy: "vehicle",
				};
				refetch();
				break;
			}
			case "productCategory":
				getProdCats({ ...defaultFilter, productCategory: e.target.value });
				break;
			case "product":
				getProducts({ ...defaultFilter, productName: e.target.value });
				break;
			case "supplier":
				getSuppliers({ ...defaultFilter, supplierName: e.target.value });
				break;
		}
	}, 500);

	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
		// console.log(formData, name, value);
	};

	const onDropdownChange = (option, name) => {
		let value = Array.isArray(option) ? option.map((_) => _.value) : option?.value || "";
		handleInput({ target: { name, value } });
		if (name == "assetType") {
			switch (option?.value) {
				case "vehicle":
					refetch();
					break;
				case "productCategory":
					getProdCats(defaultFilter);
					break;
				case "product":
					getProducts(defaultFilter);
					break;
				case "supplier":
					getSuppliers(defaultFilter);
					break;
			}
		}
	};

	const tagRef = useRef({
		displayName: "",
	});

	// Tag query, options and value builder
	const { tags } = useTags(tagRef.current, "getModalTags");
	let tagOptions = tags
		? tags.map((ele) => ({
				label: ele.displayName,
				value: {
					tag_tid: ele.tId,
					tag_epc: ele.epc,
					tagType: ele.tagType,
					displayName: ele.displayName,
				},
		  }))
		: [];
	let tagValue = tagOptions.filter((options) => formData.tagData.find((tag) => tag.displayName === options?.value?.displayName));

	const [handleMapVehicleTag, { isLoading: isAttaching }] = useMapVehicleTagMutation();
	const handleFormSubmit = async () => {
		const payload = { ...formData, plantId: plantId };
		const {
			data: { error, message },
		} = await handleMapVehicleTag(payload);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			onUpdateSuccess();
			handleClose();
		}
	};

	const handleFormValidation = () => {
		let error = {};
		if (!formData.assetType) error.assetType = "Asset Type is required";
		if (!formData.assetId) error.assetId = "Vehicle Number is required";
		if (formData.tagData.length === 0) error.tagData = "Tag is required";
		if (Object.keys(error).length) {
			setError(error);
		} else {
			handleFormSubmit();
		}
	};
	const handleClose = () => {
		setFormData(defaultForm);
		setError({});
		onClose();
	};
	return (
		<Dialog size="sm" open={open} handleClose={handleClose} handleSubmit={handleFormValidation} title={"Attach Tag"} isSubmitDisabled={isAttaching}>
			<form className="form-inputs flex-col">
				<Dropdown
					id={"assetType"}
					name={"assetType"}
					label={"Select Asset Type"}
					onChange={onDropdownChange}
					options={assetMappingSupport ? multiAssetTypeOptions : assetTypeOptions}
					value={multiAssetTypeOptions.find((ele) => ele.value === formData.assetType)}
					error={error.assetType}
					required={true}
				/>
				<Dropdown
					id={"vehicleId"}
					name={"assetId"}
					label={"Select Asset"}
					onChange={onDropdownChange}
					onInputChange={(e) => onInputChange(e)}
					options={isVehicleLoading ? [{ label: "Loading...", value: "loading" }] : assetOptions || []}
					value={assetOptions.find((ele) => ele.value === formData.assetId)}
					error={error.assetId}
					required={true}
					getOptionDisabled={(option) => {
						// disable vehicle option when org doesnt have multi tag support and vehicle has been allocated a tag
						if (formData.assetType == "vehicle" && !userPermissions?.multiTagSupport?.value && (option?.data?.formData?.epc || option?.data?.formData?.tId)) {
							return true;
						}
						return false;
					}}
				/>
				<Dropdown
					id={"tag"}
					name={"tagData"}
					label={"Tag"}
					onChange={onDropdownChange}
					options={tagOptions}
					value={tagValue}
					error={error.tagData}
					multiple={true}
					getOptionDisabled={() => (!multiTagSupport && tagValue?.length == 1 ? true : false)}
					required={true}
				/>
				<Checkbox
					id={"isTrackable"}
					name={"isTrackable"}
					checked={formData.isTrackable}
					onChange={() => setFormData((old) => ({ ...old, isTrackable: !old.isTrackable }))}
					label="Is Trackable"
				/>
			</form>
		</Dialog>
	);
}
